import { css, Theme } from '@emotion/react'
import { selectClasses } from '@mui/material'
import { RolesEnum } from '__generatedTypes__/globalTypes'

export const container = (theme: Theme) => css`
  display: flex;
  column-gap: ${theme.spacing(3)};
`

export const title = css`
  font-size: 22px;
  font-weight: 700;
`

export const titleWithFilters = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0 24px;
  flex-wrap: wrap;
`

export const form = (theme: Theme) => css`
  max-width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  row-gap: ${theme.spacing(3)};
`

export const field = (theme: Theme) => css`
  margin-top: ${theme.spacing(3)};
`

const getRoleColumnsCount = (prevRole?: RolesEnum | null, newRole?: RolesEnum | null) => {
  switch (newRole) {
    case RolesEnum.Teacher:
      return 3
    case RolesEnum.User:
      return 4
    case RolesEnum.UGCCreator:
      return prevRole === RolesEnum.UGCCreator ? 3 : 1
  }
  return 1
}

export const userRoleWrapper = (prevRole?: RolesEnum | null, newRole?: RolesEnum | null) => (theme: Theme) => {
  const columnsCount = getRoleColumnsCount(prevRole, newRole)

  return css`
    display: grid;
    grid-template-columns: repeat(${columnsCount}, minmax(0, 1fr));
    gap: ${theme.spacing(3)};

    ${theme.breakpoints.down('lg')} {
      grid-template-columns: repeat(${Math.ceil(columnsCount / 2)}, minmax(0, 1fr));
    }

    ${theme.breakpoints.down('sm')} {
      grid-template-columns: 1fr;
    }
  `
}

export const selectOption = css`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`

export const cohortField = css`
  overflow: hidden;
`

export const roleField = css`
  .${selectClasses.disabled} {
    color: rgba(0, 0, 0, 0.38);
  }
`

export const roleButton = css`
  margin-top: 30px;
`

export const buttonsWrapper = (theme: Theme) => css`
  display: flex;
  justify-content: flex-end;
  column-gap: ${theme.spacing(1.25)};

  margin-top: ${theme.spacing(1.25)};
`

export const resetPasswordLabel = (theme: Theme) => css`
  font-size: 16px;
  color: ${theme.colors.typographyThree};
`

export const resetPasswordCaption = (theme: Theme) => css`
  margin-top: ${theme.spacing(1.25)};

  font-size: 12px;
  color: ${theme.colors.typographyThree};
`

export const sendLinkButton = (theme: Theme) => css`
  margin-top: ${theme.spacing(1.25)};
`

export const heading = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(1)};
`

export const totalScreenshotWarningsText = css`
  font-weight: 500;
  font-size: 14px;
`
